/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Mohamed Fadl's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Mohamed Fadl Portfolio",
    type: "website",
    url: "https://mohamed_fadl.github.io.com/portfolio",
  },
};

//Home Page
const greeting = {
  title: "Mohamed Fadl",
  logo_name: "MohamedFadl",
  subTitle:
    "A passionate AI Software Engineer who always thrives to work on end to end products which develop sustainable and scalable social and technical systems.",
  resumeLink:
    "https://drive.google.com/file/d/1ziIgawCDAkrvicIfOMdLvNWVN4ItA0HB",
  portfolio_repository: "https://github.com/mohnabilfadl/portfolio",
  githubProfile: "https://github.com/mohnabilfadl",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/mohnabilfadl",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mohamed-fadl/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:mohnabilfadl@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
        "⚡ Experience integrating with llms models like gpt-3.5, llama, .... into any system",
        "⚡ Experience of creating and deploying chatbots using Rasa or using openai api",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end ",
        "⚡ Creating application backend in Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Deploying machine and deep learning models on cloud",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/mohnabil/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/mohnabil",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/eng0mohamed0nabil",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Faculty of Engineering, Mansoura University",
      subtitle: "Master of Science in Computer Engineering (M.Sc.)",
      logo_path: "mansoura_university.png",
      alt_name: "Mansoura University",
      duration: "2024 - in progress",
      descriptions: [
        "⚡ A master's in computer engineering explores advanced topics like computer architecture, software design, artificial intelligence, data science, and network engineering to innovate in technology and solve complex problems across diverse domains. This program offers a blend of theoretical knowledge and practical skills, empowering one to excel in fields requiring expertise in hardware, software, and data-driven solutions.",
      ],
      website_link: "https://engfac.mans.edu.eg/index.php/en/",
    },
    {
      title: "Information Technology Institute (ITI)",
      subtitle: "Professional Diploma in Artificial Intelligence",
      logo_path: "ITI.png",
      alt_name: "ITI",
      duration: "2021 - 2022",
      descriptions: [
        "⚡ The Artificial Intelligence Professional (AI-Pro) program is a 9-month post-graduate professional training program in Machine Learning and Artificial Intelligence. The program provides a unique learning experience with a balance between theoretical foundations, practical tools, and applications. Enabling a vast number of job opportunities in the fastest-growing field of technology. The program is developed in partnership with the French Graduate School of Computer Science and Advanced Technologies (EPITA).",
      ],
      website_link: "https://iti.gov.eg/iti/home",
    },
    {
      title: "Faculty of Engineering, Mansoura University",
      subtitle: "Bachelor of Science in Engineering (B.Sc.)",
      logo_path: "mansoura_university.png",
      alt_name: "Mansoura University",
      duration: "2015 - 2020",
      descriptions: [
        "⚡A comprehensive academic program designed to provide with a solid foundation in the field of engineering. Focusing on equipping with theoretical knowledge, practical skills, and problem-solving abilities necessary to tackle real-world engineering challenges.",
      ],
      website_link: "https://engfac.mans.edu.eg/index.php/en/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "AWS Certified Machine Learning - Specialty",
      logo_path: "aws.jpg",
      certificate_link:
        "https://www.credly.com/badges/c4f32720-ce27-472e-abe8-0174cf45c0f2/public_url",
      alt_name: "AWS Certified Machine Learning - Specialty",
      color_code: "#222f3d",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1Zt9SpZoGudwL7QfLDbDHnfpSIWdMy3AF/view?usp=sharing",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1LglyaIzUNaAHGaPeB17zH2Jr4my1bLAP/view?usp=sharing",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Certified Data Scientist",
      subtitle: "- 365 Data Science",
      logo_path: "365 data.png",
      certificate_link:
        "https://learn.365datascience.com/certificates/DD-CE1949D4D3/",
      alt_name: "365 Data Science",
      color_code: "#000c1f",
    },
    {
      title: "AWS Machine Learning Foundations Program",
      subtitle: "- Udacity",
      logo_path: "udacity.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Udacity",
      color_code: "#FFBB0099",
    },
    {
      title: "Data Science Professional Program",
      subtitle: "- DataCamp",
      logo_path: "datacamp.png",
      certificate_link:
        "https://www.datacamp.com/statement-of-accomplishment/track/d2580f5b584119d37519e61d9031570b60ace79a",
      alt_name: "datacamp",
      color_code: "#05192d",
    },
    {
      title: "Web Development Professional Nanodegree",
      subtitle: "- Udacity",
      logo_path: "udacity.png",
      certificate_link: "https://graduation.udacity.com/confirm/4ZDZSK3C",
      alt_name: "Udacity",
      color_code: "#FFBB0099",
    },
    {
      title: "DeepLearning.AI TensorFlow Developer",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1ghy_-KuEeUTZLRfGsqUXzG2KW8S8xGy_/view?usp=sharing",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "IT Essentials: PC Hardware and Software",
      subtitle: "- Cisco Networking Academy",
      logo_path: "cisco.png",
      certificate_link:
        "https://drive.google.com/file/d/1MdnfPk7w24Vic1O7CpzftW12bM-YwPPx/view?usp=sharing",
      alt_name: "Cisco",
      color_code: "#00a2df",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have worked with many evolving startups as ML and DL Developer, Designer and Software Architect. I have also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Machine Learning Engineer",
          company: "FlairsTech",
          company_url: "https://flairstech.com/",
          logo_path: "flairstech.png",
          duration: "Jul 2022 - Present",
          location: "Cairo, Egypt",
          description:
            "Contributing to a variety of projects to serve the requirments of the company business and to improve my software and analysis skills ex Pulse technical due diligence, Rasa chatbot and Voice call analysis app",
          color: "#0879bf",
        },
        {
          title: "Top Rated Machine Learning Engineer",
          company: "Upwork",
          company_url: "https://www.upwork.com/freelancers/~011f3d93916d72ad6c",
          logo_path: "upwork.png",
          duration: "Nov 2021 - Present",
          location: "Remote-FreeLance",
          description:
            "As a top rated freelancer on Upwork, I have worked with many clients on different projects and different mentoring sessions on machine learning and data science.I got 100% job success score and 5 stars rating from all my clients.You can check my profile and reviews on Upwork from the link above.",
          color: "#9b1578",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Machine Learning and Data Science Intern",
          company: "Kaggle",
          company_url: "https://www.kaggle.com/eng0mohamed0nabil",
          logo_path: "kaggle.png",
          duration: "April 2020 - Nov 2021",
          location: "Remote",
          description:
            "I am Having an Expert badge in the Kaggle platform due to contributing to Discussions, Datasets, Notebooks, and Competitions in the kaggle platform. These contributions are in the data science and machine learning domain",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Remote",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

// const publicationsHeader = {
//   title: "Publications",
//   description:
//     "I have worked on and published a few research papers and publications of my own.",
//   avatar_image_path: "projects_image.svg",
// };

// const publications = {
//   data: [
//     {
//       id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
//       name: "Artificial Intelligence Paper",
//       createdAt: "2020-03-06T16:26:54Z",
//       description: "Paper Written on Artificial Intelligence published in xyz ",
//       url:
//         "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
//     },
//     {
//       id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
//       name: "Artificial Intelligence Paper",
//       createdAt: "2020-03-06T16:26:54Z",
//       description: "Paper Written on Artificial Intelligence published in xyz ",
//       url:
//         "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
//     },
//     {
//       id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
//       name: "Artificial Intelligence Paper",
//       createdAt: "2020-03-06T16:26:54Z",
//       description: "Paper Written on Artificial Intelligence published in xyz ",
//       url:
//         "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
//     },
//     {
//       id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
//       name: "Artificial Intelligence Paper",
//       createdAt: "2020-03-06T16:26:54Z",
//       description: "Paper Written on Artificial Intelligence published in xyz ",
//       url:
//         "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
//     },
//     {
//       id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
//       name: "Artificial Intelligence Paper",
//       createdAt: "2020-03-06T16:26:54Z",
//       description: "Paper Written on Artificial Intelligence published in xyz ",
//       url:
//         "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
//     },
//   ],
// };

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "mohamed_fadl.png",
    description:
      "You can message me, I will reply within 24 hours. I can help you with ML, AI, Software Development.",
  },
  // blogSection: {
  //   title: "Blogs",
  //   subtitle:
  //     "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
  //   link: "https://blogs.ashutoshhathidara.com/",
  //   avatar_image_path: "blogs_image.svg",
  // },
  // addressSection: {
  //   title: "Address",
  //   subtitle:
  //     "Ambavadi vas, Kanodar, T.A.-Palanpur, Dist.-Banaskantha, Gujarat - 385520",
  //   locality: "Kanodar",
  //   country: "IN",
  //   region: "Gujarat",
  //   postalCode: "385520",
  //   streetAddress: "Ambavadi vas",
  //   avatar_image_path: "address_image.svg",
  //   location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  // },
  // phoneSection: {
  //   title: "",
  //   subtitle: "",
  // },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
